import React, { useState } from "react";
import ProductPicker from "../externalComponents/ProductPicker";
import { PageHeading } from "../externalComponents";

const TestProductPickerPage = () => {
  const [selectedVariants, setSelectedVariants] = useState([]);

  const handleSelectionChange = (variants) => {
    setSelectedVariants(variants);
  };

  const handleCreateDraftOrder = async (selectedData) => {
    if (!selectedData || selectedData.length === 0) {
      alert("Please select at least one product variant.");
      return;
    }

    try {
      // Log the selected data as JSON
      console.log(
        "Selected variants JSON:",
        JSON.stringify(selectedData, null, 2),
      );

      // Show the JSON data to the user
      alert(
        `Selected ${selectedData.length} items! Check console for JSON data.`,
      );
    } catch (error) {
      console.error("Error processing selection:", error);
      alert("Error processing selection. Please try again.");
    }
  };

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <PageHeading
        title="Product Picker Test Page"
        subtitle="Select products to create a draft order"
      />

      <div className="mt-6">
        <ProductPicker
          onSelectionChange={handleSelectionChange}
          selectedVariants={selectedVariants}
          onCreateDraftOrder={handleCreateDraftOrder}
        />
      </div>
    </div>
  );
};

export default TestProductPickerPage;
